const FILTER_PAGINATION_SIZE = 100;
const CUSTOM_PRICE_RANGE_FILTER_ID = 'custom-price-range';
const FILTER_DELIMITER = ',';
const FILTER_MODAL_HASH = '#filter';
const GENERIC_FACET_DELIMITER = ';';
const GENERIC_FACET_PREFIX_DELIMITER = ':';
const PRICE_RANGE_FILTER_NAME_DELIMITER = ' - ';
const PRICE_RANGE_FILTER_VALUE_DELIMITER = '-';
const PRICE_RANGE_FILTER_VALUE_SUFFIX = '.0';
const PRICE_RANGE_FILTER_CURRENCY_SUFFIX = ' TL';
const PRICE_RANGE_FILTER_MIN_PRICE_PLACEHOLDER = 'min';
const PRICE_RANGE_FILTER_MAX_PRICE_PLACEHOLDER = 'max';
const MINIMUM_RANGE_ID = 'min-1';
const SEARCHBOX_VISIBLE_MINIMUM_LIMIT = 20;
const DEFAULT_ALL_CATEGORY_ID = '999999999';

const NEXT_DAY_DELIVERY_FACET_CUSTOM_ID = 'nextDayDeliveryFacet';
const NEXT_DAY_DELIVERY_FILTER_CUSTOM_ID = 'nextDayDeliveryFilter';
const EXPRESS_DELIVERY_FACET_CUSTOM_ID = 'expressDeliveryFacet';
const EXPRESS_DELIVERY_FILTER_CUSTOM_ID = 'expressDeliveryFilter';

const CAMPAING_FILTER_FACET_ID = 'VariantList.VariantListing.TagList.Special€20Offers';
const CAMPAIGN_FILTER_LOCATION_NAME = 'campaign filter';

const DELIVERY_CHECKBOX_CHANGE_EVENT = 'storefront.delivery.statusChange';
const DELIVERY_CHECKBOX_SET_EVENT = 'storefront.delivery.HbCheckbox.checked';
const DELIVERY_CHECKBOX_DISABLE_EVENT = 'storefront.delivery.HbCheckbox.checked.disabled';
const DELIVERY_CHECKBOX_VISIBILITY_EVENT = 'storefront.delivery.HbCheckbox.visibility';

const GENERIC_FILTER_ANCHOR_TEXT_REPLACE = '{path}';

const WORD_FILTER_MINIMUM_KEYWORD_LENGTH = 2;

const TRIGGER_QUICK_FILTER = 'triggerQuickFilter';

export {
  FILTER_PAGINATION_SIZE,
  CUSTOM_PRICE_RANGE_FILTER_ID,
  FILTER_DELIMITER,
  FILTER_MODAL_HASH,
  GENERIC_FACET_DELIMITER,
  GENERIC_FACET_PREFIX_DELIMITER,
  PRICE_RANGE_FILTER_NAME_DELIMITER,
  PRICE_RANGE_FILTER_VALUE_DELIMITER,
  PRICE_RANGE_FILTER_VALUE_SUFFIX,
  PRICE_RANGE_FILTER_CURRENCY_SUFFIX,
  PRICE_RANGE_FILTER_MIN_PRICE_PLACEHOLDER,
  PRICE_RANGE_FILTER_MAX_PRICE_PLACEHOLDER,
  MINIMUM_RANGE_ID,
  SEARCHBOX_VISIBLE_MINIMUM_LIMIT,
  DELIVERY_CHECKBOX_CHANGE_EVENT,
  DELIVERY_CHECKBOX_SET_EVENT,
  DELIVERY_CHECKBOX_DISABLE_EVENT,
  DELIVERY_CHECKBOX_VISIBILITY_EVENT,
  DEFAULT_ALL_CATEGORY_ID,
  CAMPAING_FILTER_FACET_ID,
  CAMPAIGN_FILTER_LOCATION_NAME,
  NEXT_DAY_DELIVERY_FACET_CUSTOM_ID,
  NEXT_DAY_DELIVERY_FILTER_CUSTOM_ID,
  EXPRESS_DELIVERY_FACET_CUSTOM_ID,
  EXPRESS_DELIVERY_FILTER_CUSTOM_ID,
  GENERIC_FILTER_ANCHOR_TEXT_REPLACE,
  WORD_FILTER_MINIMUM_KEYWORD_LENGTH,
  TRIGGER_QUICK_FILTER
};
